import React from "react";
import Backgroundimage from "../../assets/images/background/image-4.jpg";
import { Link } from "react-router-dom";

function Main() {
  return (
    <>
      <footer className="main-footer">
        <div
          className="image-layer"
          style={{ backgroundImage: `url(${Backgroundimage})` }}
        >
          {" "}
        </div>
        <div className="upper-section">
          <div className="auto-container">
            <div className="row clearfix">
              <div className="footer-col info-col col-lg-6 col-md-12 col-sm-12">
                <div
                  className="inner wow fadeInUp"
                  data-wow-delay="0ms"
                  data-wow-duration="1500ms"
                >
                  <div className="content">
                    <div className="logo">
                      <Link to="/">
                        <span style={{ fontWeight: 900, fontSize: "36px" }}>
                          X-GROUP
                        </span>
                      </Link>
                    </div>
                    <div className="info">
                      <ul>
                        <li>
                          House No. 59/A, Sheikh Kamal Saroni Sat Masjid Road,
                          Dhanmondi, Dhaka-1209.
                        </li>
                        <li>
                          <a href="mailto:admin@x-grouprestaurant.com">
                            admin@x-grouprestaurant.com
                          </a>
                        </li>
                        <li>
                          <a href="tel:01755636335">
                            Booking Request : 01755636335
                          </a>
                        </li>
                        <li>Open : 12:00 pm - 10:30 pm</li>
                      </ul>
                    </div>
                    <div className="separator">
                      <span></span>
                      <span></span>
                      <span></span>
                    </div>
                    <div className="newsletter">
                      <h3>Get News & Offers</h3>
                      <div className="text">
                        Subscribe us & Get <span>25% Off.</span>
                      </div>
                      <div className="newsletter-form">
                        <form method="post" action="/">
                          <div className="form-group">
                            <span className="alt-icon far fa-envelope"></span>
                            <input
                              type="email"
                              name="email"
                              placeholder="Your email"
                              required
                            />
                            <button
                              type="submit"
                              className="theme-btn btn-style-one clearfix"
                            >
                              <span className="btn-wrap">
                                <span className="text-one">subscribe</span>
                                <span className="text-two">subscribe</span>
                              </span>
                            </button>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="footer-col links-col col-lg-3 col-md-6 col-sm-12">
                <div
                  className="inner wow fadeInLeft"
                  data-wow-delay="0ms"
                  data-wow-duration="1500ms"
                >
                  <ul className="links">
                    <li>
                      <Link to="/">Home</Link>
                    </li>
                    <li>
                      <Link to="/about">About Us</Link>
                    </li>
                    <li>
                      <Link to="/menu">Menus</Link>
                    </li>
                    <li>
                      <Link to="/sister-concern">Sister Concern</Link>
                    </li>
                    <li>
                      <Link to="/managements">Management</Link>
                    </li>
                    <li>
                      <Link to="/contact">Contact</Link>
                    </li>
                  </ul>
                </div>
              </div>

              <div className="footer-col links-col last col-lg-3 col-md-6 col-sm-12">
                <div
                  className="inner wow fadeInRight"
                  data-wow-delay="0ms"
                  data-wow-duration="1500ms"
                >
                  <ul className="links">
                    <li>
                      {" "}
                      <Link to="https://www.facebook.com">facebook</Link>
                    </li>
                    <li>
                      {" "}
                      <Link to="https://www.instagram.com">instagram</Link>
                    </li>
                    <li>
                      {" "}
                      <Link to="https://twitter.com">Twitter</Link>
                    </li>
                    <li>
                      {" "}
                      <Link to="https://www.youtube.com">Youtube</Link>
                    </li>
                    <li>
                      {" "}
                      <Link to="https://www.google.com/maps">Google map</Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <div className="auto-container">
            <div class="copyright">
              &copy; 2024 Restaurt. All Rights Reserved | Crafted by
              <Link to="https://www.x-grouprestaurant.com/" target="blank">
                X-group Chain Restaurant
              </Link>
            </div>
          </div>
        </div>
      </footer>
      <div className="scroll-to-top scroll-to-target" data-target="html">
        <span className="icon fa fa-angle-up"></span>
      </div>
    </>
  );
}

export default Main;
